/* eslint-disable */
import React, { useContext, useState } from 'react';
import { Box, Typography, TextField, IconButton } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import InputAdornment from '@mui/material/InputAdornment';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import AuthLayout from 'Shared/AuthLayout';
import AuthCard from 'Shared/AuthCard';
import AuthButton from 'Shared/UI/AuthButton';
import UserContext from 'Shared/UserContext';
import { changeFirstPassword } from 'Components/Login/LoginService';
import eyeicon from 'Components/Login/icons/eyeicon.png';

/* ── Shared field styles (same as Login page) ──────────────── */
const fieldSx = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    width: '100%',
    height: '48px',
    backgroundColor: '#F8FAFC',
    borderRadius: '8px',
    fontSize: '14px',
    opacity: 1,
    '& fieldset': { borderColor: '#DEE5EE', borderWidth: '1px' },
    '&:hover fieldset': { borderColor: '#007BC6' },
    '&.Mui-focused fieldset': { borderColor: '#007BC6', borderWidth: '2px' },
  },
};

const LabeledField = ({ label, children }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#8397AE', fontFamily: 'Open Sans' }}>
      {label}
    </Typography>
    {children}
  </Box>
);

const PasswordField = ({ label, value, onChange }) => {
  const [show, setShow] = useState(false);
  return (
    <LabeledField label={label}>
      <TextField
        fullWidth
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        sx={fieldSx}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShow(!show)} onMouseDown={(e) => e.preventDefault()} edge="end" size="small">
                {show
                  ? <img src={eyeicon} alt="hide" style={{ width: 20, height: 20 }} />
                  : <img src={eyeicon} alt="show" style={{ width: 25, height: 20 }} />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </LabeledField>
  );
};

/* ── UpdatePassword page ───────────────────────────────────── */
const UpdatePassword = () => {
  const history = useHistory();
  const { dispatch, state: { status, errorMessage, firstLogin } } = useContext(UserContext);

  const [values, setValues] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const hasError = status === 'error';

  const handleChange = (field) => (e) => {
    setValues((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const isValid = values.currentPassword
    && values.newPassword
    && values.newPassword === values.confirmPassword;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!isValid) return;
    await changeFirstPassword(
      dispatch,
      { oldPassword: values.currentPassword, newPassword: values.newPassword },
      history,
      firstLogin?.tmpUser,
      firstLogin?.tmpToken,
    );
  };

  const subtitle = hasError
    ? (errorMessage || 'Une erreur est survenue')
    : 'Veuillez changer votre mot de passe pour continuer';

  return (
    <>
      {status === 'loading' && <GlobalLoader size="100vh" />}
      <AuthLayout>
        <AuthCard title="Mise à jour du mot de passe" subtitle={subtitle} hasError={hasError}>
          <form noValidate autoComplete="off" onSubmit={onSubmit} style={{ width: '100%' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', mt: '16px', width: '100%' }}>
              <PasswordField
                label="Mot de passe actuel :"
                value={values.currentPassword}
                onChange={handleChange('currentPassword')}
              />
              <PasswordField
                label="Nouveau mot de passe :"
                value={values.newPassword}
                onChange={handleChange('newPassword')}
              />
              <PasswordField
                label="Confirmer le nouveau mot de passe :"
                value={values.confirmPassword}
                onChange={handleChange('confirmPassword')}
              />
            </Box>

            <AuthButton type="submit" disabled={!isValid}>
              Sauvegarder
            </AuthButton>
          </form>
        </AuthCard>
      </AuthLayout>
    </>
  );
};

export default UpdatePassword;